/**
 * Handles the received category id's by mapping to store and returning results.
 * @param {Array} categories The received categories.
 * @returns {Array} An array of category objects.
 */var handleReceivedCategories=function handleReceivedCategories(categories){return categories.length?categories.map(function(category){return category.id;}):null;};export default handleReceivedCategories;